export interface JobState {
  status: JobStatus;
  progressValue: number;
  progressTotal: number;
}

export enum JobStatus {
  INNACTIVE = "INNACTIVE",
  RUNNING = "RUNNING",
  FAILED = "FAILED",
  FINISHED = "FINISHED",
}

export interface ProgressState {
  value: number;
  total: number;
}
